<template>
  <svg
    width="280"
    height="180"
    viewBox="0 0 280 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.8303 132.93H176.1C176.74 132.93 177.37 132.86 177.97 132.73C178.57 132.86 179.2 132.93 179.84 132.93H244.57C249.38 132.93 253.28 129.03 253.28 124.22C253.28 119.41 249.38 115.51 244.57 115.51H237.1C232.29 115.51 228.39 111.61 228.39 106.8C228.39 101.99 232.29 98.0901 237.1 98.0901H260.75C265.56 98.0901 269.46 94.1901 269.46 89.3801C269.46 84.5701 265.56 80.6701 260.75 80.6701H233.37C238.18 80.6701 242.08 76.7701 242.08 71.9601C242.08 67.1501 238.18 63.2501 233.37 63.2501H153.71C158.52 63.2501 162.42 59.3501 162.42 54.5401C162.42 49.7301 158.52 45.8301 153.71 45.8301H82.7603C77.9503 45.8301 74.0503 49.7301 74.0503 54.5401C74.0503 59.3501 77.9503 63.2501 82.7603 63.2501H32.9703C28.1603 63.2501 24.2603 67.1501 24.2603 71.9601C24.2603 76.7701 28.1603 80.6701 32.9703 80.6701H64.0903C68.9003 80.6701 72.8003 84.5701 72.8003 89.3801C72.8003 94.1901 68.9003 98.0901 64.0903 98.0901H14.2803C9.47031 98.0901 5.57031 101.99 5.57031 106.8C5.57031 111.61 9.47031 115.51 14.2803 115.51H62.8303C58.0203 115.51 54.1203 119.41 54.1203 124.22C54.1203 129.03 58.0203 132.93 62.8303 132.93ZM265.72 132.93C270.53 132.93 274.43 129.03 274.43 124.22C274.43 119.41 270.53 115.51 265.72 115.51C260.91 115.51 257.01 119.41 257.01 124.22C257.01 129.03 260.91 132.93 265.72 132.93Z"
      fill="#F9FAFB"
    />
    <path
      d="M85.1292 125.79H82.6992C80.4892 125.79 78.6992 124 78.6992 121.79V55.9902C78.6992 53.7802 80.4892 51.9902 82.6992 51.9902H202.699C204.909 51.9902 206.699 53.7802 206.699 55.9902V121.79C206.699 124 204.909 125.79 202.699 125.79H103.439"
      fill="white"
    />
    <path
      d="M85.1292 125.79H82.6992C80.4892 125.79 78.6992 124 78.6992 121.79V55.9902C78.6992 53.7802 80.4892 51.9902 82.6992 51.9902H202.699C204.909 51.9902 206.699 53.7802 206.699 55.9902V121.79C206.699 124 204.909 125.79 202.699 125.79H103.439"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M99.0891 125.79H89.6191"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M200.699 55.3496H84.6992C83.5946 55.3496 82.6992 56.245 82.6992 57.3496V120.44C82.6992 121.544 83.5946 122.44 84.6992 122.44H200.699C201.804 122.44 202.699 121.544 202.699 120.44V57.3496C202.699 56.245 201.804 55.3496 200.699 55.3496Z"
      fill="#EFF2F8"
    />
    <path
      d="M119.199 60.46H169.199C171.409 60.46 173.199 62.25 173.199 64.46V114.46C173.199 115.56 172.299 116.46 171.199 116.46H119.199C118.099 116.46 117.199 115.56 117.199 114.46V62.46C117.199 61.36 118.099 60.46 119.199 60.46Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M166.779 112.46H122z.189C121.639 112.46 121.189 112.01 121.189 111.46V66.8702C121.189 65.9802 122.269 65.5302 122.899 66.1602L167.489 110.75C168.119 111.38 167.669 112.46 166.779 112.46Z"
      fill="#EFF2F8"
    />
    <path
      d="M152.221 75.6999C148.211 71.1599 141.161 71.1599 137.161 75.6999C134.501 78.7199 134.041 83.0999 135.691 86.7599L143.511 104.05C143.971 105.07 145.411 105.07 145.871 104.05C147.791 99.7999 151.581 91.4099 153.691 86.7499C155.351 83.0799 154.881 78.7099 152.221 75.6899V75.6999ZM145.401 85.2599C142.861 85.7399 140.671 83.5499 141.151 81.0099C141.421 79.5999 142.571 78.4399 143.991 78.1699C146.531 77.6899 148.721 79.8799 148.241 82.4199C147.971 83.8299 146.821 84.9899 145.401 85.2599Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M100.163 60.4718L52.3461 64.6553C50.1454 64.8478 48.5174 66.788 48.71 68.9887L52.8934 116.806C53.086 119.007 55.0261 120.635 57.2268 120.442L105.044 116.259C107.245 116.066 108.873 114.126 108.68 111.925L104.497 64.108C104.304 61.9072 102.364 60.2793 100.163 60.4718Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M89.3167 79.8778L66.24 82.0633C64.0407 82.2716 62.4267 84.2233 62.6349 86.4226L63.6805 97.4632C63.8888 99.6625 65.8405 101.277 68.0398 101.068L91.1166 98.8828C93.3159 98.6745 94.9299 96.7228 94.7216 94.5235L93.676 83.4829C93.4678 81.2836 91.516 79.6696 89.3167 79.8778Z"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M90.9702 80.8896L80.7701 93.3997C79.8701 94.4797 78.2702 94.6396 77.1902 93.7396L64.1602 82.9697"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.548 64.6581L190.731 60.4746C188.53 60.2821 186.59 61.91 186.397 64.1108L182.214 111.928C182.021 114.129 183.649 116.069 185.85 116.262L233.667 120.445C235.868 120.638 237.808 119.01 238.001 116.809L242.184 68.9915C242.377 66.7907 240.749 64.8506 238.548 64.6581Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M215.14 98.3L218.12 95.24C218.95 94.39 220.23 94.19 221.28 94.74L227.46 97.97C228.66 98.59 229.2 100.01 228.73 101.27L226.61 107.01C226.19 108.14 225.07 108.86 223.87 108.75C207.35 107.3 195.13 92.74 196.57 76.22C196.68 75.02 197.58 74.03 198.77 73.81L204.79 72.72C206.12 72.48 207.41 73.26 207.82 74.55L209.93 81.19C210.29 82.32 209.86 83.55 208.88 84.21L205.35 86.62C207.16 91.52 210.64 95.65 215.14 98.29V98.3Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M225.48 68.3496L234.45 69.1296C235.55 69.2296 236.36 70.1996 236.27 71.2996L235.59 79.0696"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M124.199 136.35H104.199"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M135.199 136.35H130.199"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M173.199 42.3496H193.199"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M151.199 37.3496H171.199"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M162.199 42.3496H167.199"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
